<template>
  <div class="asd-form">
    <div class="asd-form-section">
      <div class="section-title">
        <div class="section-title-controls">
          <ActiveButton v-if="resourceId !== null"
                        v-help.mouse="`Uložit zdroj`"
                        class="asd-btn-confirm"
                        :click="save"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
          <ActiveButton v-if="resourceId === null"
                        v-help.mouse="`Vytvořit zdroj`"
                        class="asd-btn-confirm"
                        :click="create"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>
      <label>Typ zdroje</label>
      <Multiselect
        v-model="data.resourceType.id"
        label="name"
        trackBy="id"
        valueByPath="id"
        :returnAsSingle="true"
        :options="$store.getters.resourceTypes"
        :allowEmpty="false"
        :max="1"
      ></Multiselect>
      <label v-if="data.resourceType.id">
        Skupina zdroje
      </label>
      <Multiselect
        v-if="data.resourceType.id"
        v-model="data.resourceTypeFunction.id"
        label="name"
        trackBy="id"
        valueByPath="id"
        :returnAsSingle="true"
        :options="resourceTypeFunctions"
        :allowEmpty="false"
        :max="1"
      ></Multiselect>
      <label v-if="data.resourceTypeFunction.id">
        Vlastnosti
      </label>
      <PropertyForm
        v-if="data.resourceTypeFunction.id"
        v-model="data.propertyValues"
        :propertyKeys="propertyKeys"
      ></PropertyForm>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import PropertyForm from 'CORE/components/form/property-form'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import FormControls from 'CORE/components/form/controls'
import ActiveButton from 'CORE/components/form/active-button'
import Vue from 'vue'
import EventBus from 'CORE/bus'

export default {
    name: 'ResourceForm',
    components: {
        PropertyForm,
        Multiselect,
        FormControls,
        ActiveButton,
    },
    props: {
        resourceId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            data: {},
        }
    },
    computed: {
        resourceTypeFunctions() {
            return _.map(this.$store.getters.resourceTypeFunctions, rtf => {
                return {
                    id: rtf.id,
                    name: this.$t('resource.function.' + rtf.name),
                }
            })
        },
        propertyKeys() {
            const rt = _.get(this.$store.getters.resourceTypeById(_.get(this.data, 'resourceType.id')), 'propertyType', [])
            return _.map(rt, r => _.get(r, 'key'))
        },
    },
    created() {
        if (this.resourceId === null) {
            this.data = {}
            Vue.set(this.data, 'id', this.$uuid.v4())
            Vue.set(this.data, 'resourceType', { id: null })
            Vue.set(this.data, 'resourceTypeFunction', { id: null })
            Vue.set(this.data, 'isTemplate', false)
        } else {
            this.data = this.$store.getters.resourceById(this.resourceId)
        }
        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing Project or invalid UUID creation)'
        )
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('updateResource', this.data)
                await this.$store.dispatch('resourcesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async create() {
            try {
                await this.$store.dispatch('createResource', this.data)
                await this.$store.dispatch('resourcesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>
